import store from '@/store';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
 
import translation_en from './en.json';
import translation_th from './th.json';
 
const resources = {
    en: {
        translation: translation_en,
    },
    b5: {
        translation: translation_th,
    },
};

store.subscribe(() => {
    let lng = store.getState().language

    i18n.use(initReactI18next).init({
        resources,
        lng,
        interpolation: {
            escapeValue: false,
        },
    });
})


export default i18n;